import { useLocation, useNavigate } from 'react-router-dom'
import { UIElement } from '../../types/UIElements'
import { useContextMotifDetails } from '../../contexts/motifDetailsContext'
import { FilterElement, useContextPanels } from '../../contexts/panelsContext'
import routePaths from '../../constants/routePaths'

const filterRoutes: Record<FilterElement, string> = {
  [UIElement.GEOFILTER]: routePaths.LOCATION,
  [UIElement.TAGFILTER]: routePaths.THEME,
  [UIElement.KEYWORDFILTER]: routePaths.TAGS,
}

// Shared by the FilterBar, the SideMenu and the Router so they all open the filter menus the same way
const useOpenFilter = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { closePanel, openFilter: openFilterPanel } = useContextPanels()
  const { areDetailsOpen, setDetailsOpen, applyTagFilter } = useContextMotifDetails()

  const prepareForFilter = () => {
    if (location.pathname !== routePaths.HOME) navigate(routePaths.HOME)
    if (areDetailsOpen) setDetailsOpen(false)
    closePanel(UIElement.GALLERY)
    closePanel(UIElement.ABOUT)
  }

  // The theme and the keyword filter start a new search, so they clear the current one.
  // The location filter keeps it until a region is picked.
  const showFilter = (filter: FilterElement) => {
    // applying a filter resets the other two, so this clears all of them
    if (filter !== UIElement.GEOFILTER) applyTagFilter(undefined)
    openFilterPanel(filter)
  }

  const openFilter = (filter: FilterElement) => {
    prepareForFilter()
    window.history.replaceState(null, '', filterRoutes[filter])
    showFilter(filter)
  }

  return { prepareForFilter, showFilter, openFilter }
}

export default useOpenFilter
